const SESSION_ID = 'sessionId';

export abstract class SessionStorage {
  public static sessionId(): string | null {
    return sessionStorage.getItem(SESSION_ID);
  }

  public static setSessionId(sessionId: string): void {
    sessionStorage.setItem(SESSION_ID, sessionId);
  }
}
